module.exports = __webpack_public_path__ + "images/11-ic804bf2428662871e2b44e9e4aef2880.svg";